function useSync() {

    function launchSync(publisher) {
        if (!publisher) return;

        const { widgetId, apiKey, widgetParamsString } = publisher;

        if (!widgetId || !apiKey) return;

        if (typeof EcalWidget !== 'undefined' && EcalWidget.launchWidgetWithAPIKey) {
            EcalWidget.launchWidgetWithAPIKey(widgetId, apiKey, {
                category: widgetParamsString,
            });
        }
    }

    return { launchSync };
}

export default useSync;
